module.exports = __webpack_public_path__ + "static/media/Card-Abstract.b805c570.svg";